export const PASSWORD_POLICY_MESSAGE = "Use at least 8 characters with uppercase, lowercase, and a number.";

export const validatePasswordStrength = (password = "") => {
  const normalized = String(password);

  if (normalized.length < 8) {
    return PASSWORD_POLICY_MESSAGE;
  }

  if (!/[A-Z]/.test(normalized) || !/[a-z]/.test(normalized) || !/\d/.test(normalized)) {
    return PASSWORD_POLICY_MESSAGE;
  }

  return "";
};